// extracted by mini-css-extract-plugin
export default {"viewport":"MobileScaleStage_viewport__chZzE","scaledBox":"MobileScaleStage_scaledBox__ZH2QJ","stage":"MobileScaleStage_stage__Hca2A"};